import "./bootstrap";

import { createApp } from "vue/dist/vue.esm-bundler";
import { createRouter, createWebHistory } from "vue-router";
import Alpine from "alpinejs";
import VueGoodTablePlugin from "vue-good-table-next";
import i18n from "./i18n";
import routes from "./routes";

import "vue-good-table-next/dist/vue-good-table-next.css";

/* import the fontawesome icons */
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faExternalLink, faCheck, faBookOpen, faPrint, faArrowRight, faInfoCircle, faHeart, faSpinner } from '@fortawesome/free-solid-svg-icons';

/* add icons to the fontawesome library */
library.add([
  faExternalLink,
  faCheck,
  faBookOpen,
  faPrint,
  faArrowRight,
  faInfoCircle,
  faHeart,
  faSpinner,
])

// Alpine JS
window.Alpine = Alpine;
Alpine.start();

// page head
import { createHead, VueHeadMixin } from "@unhead/vue";
const head = createHead();

// Vue router
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

const app = createApp({});

// global variables
app.config.globalProperties.$app = window.app;

app.config.globalProperties.$window = window;

app.config.globalProperties.$filters = {
  striphtml(value) {
    const div = document.createElement('div');
    div.innerHTML = value;
    return (div.textContent || div.innerText || '');
  },
}

// plugins
app.use(VueGoodTablePlugin);
app.use(router);
app.use(i18n);
app.mixin(VueHeadMixin);
app.use(head);
app.component('font-awesome-icon', FontAwesomeIcon);

app.mount("#app");

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
